import React, {useState, useEffect, Suspense} from 'react'
import { Layout, ConfigProvider, theme} from 'antd'
import 'antd/dist/reset.css'
import './i18n';

import './index.css'

import {useAuth} from "./hooks/auth.hook"
import {AuthContext} from "./context/AuthContext";
import { mainRoutes } from "./routes/routesData";


import {RouterProvider} from 'react-router-dom';

import locale from "antd/es/locale/ru_RU";
import dayjs from "dayjs";
import 'dayjs/locale/uz';
import ChartQueryContextProvider from "./context/chartQueryContext/ChartQueryContextProvider";
import RecentlyComeMenusProvider from "./context/recentlyComeMenus/RecentlyComeMenusProvider";
import {FilterProvider} from "./context/FilterContext";
import {useTheme} from "./context/ThemeContext";
import {TitleContext} from "./context/TitleContext";
import {useTranslation} from "react-i18next";
import {useAutoLogOut} from "./hooks/useAutoLogOut";
import {EimzoProvider} from "eimzo-client/react";


function App() {

    dayjs.locale('uz');

    const {  i18n } = useTranslation();

    /*window.onbeforeunload = (event) => {
    const e = event || window.event;
    e.preventDefault();
    if (e) {
      e.returnValue = "";
    }
    return "";
    };*/  // NUJEN DLYA OSTATSYA ILI UYTI SO STRANICI

    const { isDarkMode} = useTheme();
    const { darkAlgorithm, defaultAlgorithm } = theme;

    const [titleNav, setTitleNav] = useState('');

    const {token, login, logout, saveFilialName, userId,  empId, empFilial, empName, filialName, empInn, ready} = useAuth();
    const isAuthenticated = !!token;

    useAutoLogOut(logout,isAuthenticated)

    useEffect(() => {
        const savedLang = localStorage.getItem('lang') || 'uz';
        i18n.changeLanguage(savedLang.toLowerCase());
    }, []);

    const customComponentColors = {
        Table: {
            rowSelectedBg: "#2b4464", //#agrobank
            rowSelectedHoverBg: "#1e3245" //#agrobank

        }
    }

    const tokenAbmbat = {
        "colorPrimary": "#00c950",
        "colorInfo": "#03859a",
        "colorSuccess": "#59d31c",
        "colorWarning": "#dcb057",
        "colorError": "#ed6b21",
        //"colorTextBase": "#050505",
        "borderRadius": 6,
        "wireframe": false,
        //"colorBgBase": "#ffffff",
        algorithm: "defaultAlgorithm"
    }


  return (

      <Layout style={{width:'100vw', height:'100vh' }}>
        <AuthContext.Provider value={{
          token, login, logout, saveFilialName, userId, isAuthenticated, empId, empFilial, empName, filialName, empInn, ready
        }}>
          <ConfigProvider
              theme={
                //algorithm: theme.defaultAlgorithm,
                //algorithm: theme.darkAlgorithm,
                  {
                      algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
                      token: tokenAbmbat,
                      components: isDarkMode
                          ? customComponentColors
                          : {
                                Table: {
                                    rowSelectedHoverBg: '#7cf6a6',  //#AGROBANK

                                }
                          }

                  }
              }
              locale={locale}
          >
            <FilterProvider>
                  <ChartQueryContextProvider>
                      <RecentlyComeMenusProvider>
                          <TitleContext.Provider value={{ titleNav, setTitleNav }}>
                              <EimzoProvider
                                  options={
                                  { apiKeys: {
                                      "localhost": "96D0C1491615C82B9A54D9989779DF825B690748224C2B04F500F370D51827CE2644D8D4A82C18184D73AB8530BB8ED537269603F61DB0D03D2104ABF789970B",
                                      "127.0.0.1": "A7BCFA5D490B351BE0754130DF03A068F855DB4333D43921125B9CF2670EF6A40370C646B90401955E1F7BC9CDBF59CE0B2C5467D820BE189C845D0B79CFC96F" }
                                    } }
                                  autoInstall>

                              {/*{ isAuthenticated && ready && <NavigationBar style={{width:'100%', height:'100%', backgroundColor:'red'}} /> }*/}

                                {/*<Layout style={{width:'100%', height:'100%', backgroundColor:'#c6c6c6'}}>

                    <div style={{width:'100%', height:'100%', backgroundColor:'#c6c6c6'}}>
                      {routes}
                    </div>

                              </Layout>*/}



                                    <>
                                {/*<TitleUpdater />*/}
                                {/*<AppRoutes routes={mainRoutes} logout={logout}/>*/}
                                        <Suspense fallback={<div>Юкланмокда...</div>}>
                                            <RouterProvider router={mainRoutes}/>
                                        </Suspense>

                                    </>

                              </EimzoProvider>
                          </TitleContext.Provider>
                      </RecentlyComeMenusProvider>
                  </ChartQueryContextProvider>
            </FilterProvider>

          </ConfigProvider>

        </AuthContext.Provider>

      </Layout>

  );
}

export default App;
